import React from "react";
import { render } from "react-dom";
import { Router, Link } from "@reach/router";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Registration from "./pages/Registration";
import ForYou from "./pages/ForYou";
import SuitabilityRating from "./pages/SuitabilityRating";
import Profile from "./pages/Profile";
import EditProfile from "./pages/EditProfile";
import EditEmail from "./pages/EditEmail";
import BodyTrait from "./pages/BodyTrait";
import Settings from "./pages/Settings";
import AddTraitConfirm from "./components/AddTraitConfirm";
import ForgotPassword from "./pages/ForgotPassword";
import { useAuth } from "./context/auth";
import { Redirect, redirectTo } from "@reach/router";
import AddTraitForm from "./pages/AddTraitForm";
import Address from "./pages/Adress";

export default function App() {
  const { isAuthenticated } = useAuth();
  const token = localStorage.getItem("accessToken");
  return (
    <>
      <Router>
        <Home path="/" />
        <Login path="/login" />
        <Registration path="/register" />
        <AddTraitConfirm path="/add-trait" />
        <AddTraitForm path="/trait-form" />
        <ForgotPassword path="/forgot-password" />
        {isAuthenticated ? (
          <>
            <ForYou path="/for-you" />
            <SuitabilityRating path="/suitability-rating" />
            <Profile path="/profile" />
            <EditProfile path="/edit-profile" />
            <EditEmail path="/email" />
            <BodyTrait path="/body-trait" />
            <Settings path="/settings" />
            <Address path="/address" />
          </>
        ) : (
          <>
            <Redirect from="/profile" to="/login"></Redirect>
            <Redirect from="/for-you" to="/login"></Redirect>
            <Redirect from="/suitability-rating" to="/login"></Redirect>
            <Redirect from="/edit-profile" to="/login"></Redirect>
            <Redirect from="/email" to="/login"></Redirect>
            <Redirect from="/body-trait" to="/login"></Redirect>
            <Redirect from="/settings" to="/login"></Redirect>
          </>
        )}
        {/* <Dash path="dashboard">
            <Profile path="profile" />
          </Dash> */}
      </Router>
    </>
  );
}

// let Dash = () => <div>Dash</div>;

// let Profile = () => <div>Dash / Profile</div>;
